import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import { type FC, useMemo } from 'react';
import {
  BannerSubText,
  BannerText,
  ChevronIcon,
  Container,
  ProfileImage,
  ProfileImageWrapper,
  StyledLoginBanner,
  TextContainer,
} from './LoginBanner.styles';

interface LoginBannerProps {
  onClick?: () => void;
  isDesktopPMT: boolean;
}

const LoginBanner: FC<LoginBannerProps> = ({ onClick, isDesktopPMT }) => {
  const { isLoggedIn, userInfo, setShowPMTPopUp, t, setIsFromEmailSyncBtn } = useGlobalState();

  const handleBannerClick = () => {
    if (isLoggedIn) return;

    if (onClick) {
      onClick();
      return;
    }

    // Open PMT onboarding popup for login flow
    setShowPMTPopUp(true);
    setIsFromEmailSyncBtn(true);
  };

  const displayName = useMemo(() => {
    return [userInfo?.firstName, userInfo?.lastName].join(' ').trim();
  }, [userInfo?.firstName, userInfo?.lastName]);

  return (
    <StyledLoginBanner onClick={handleBannerClick} $isLoggedIn={isLoggedIn} $isDesktopPMT={isDesktopPMT}>
      {isLoggedIn && userInfo ? (
        // Logged in state
        <Container>
          <ProfileImageWrapper>
            {userInfo.profilePictureUrl ? (
              <ProfileImage
                src={userInfo.profilePictureUrl}
                alt={displayName || 'User profile'}
                width={48}
                height={48}
              />
            ) : (
              <ProfileImage src='/images/person.svg' alt='Default user' width={20} height={20} />
            )}
          </ProfileImageWrapper>
          <TextContainer>
            {displayName && <BannerText>{displayName}</BannerText>}
            <BannerSubText>{t(MasterTranslation.AccLoggedInAs).replace('{email}', userInfo.email)}</BannerSubText>
          </TextContainer>
        </Container>
      ) : (
        // Guest state
        <Container>
          <ProfileImageWrapper>
            <ProfileImage src='/images/person.svg' alt='person' width={20} height={20} />
          </ProfileImageWrapper>
          <TextContainer>
            <BannerText>{t(MasterTranslation.AccNotLogin)}</BannerText>
            <BannerSubText>{t(MasterTranslation.AccConnectEmailToLogIn)}</BannerSubText>
          </TextContainer>
        </Container>
      )}
      {!isLoggedIn && <ChevronIcon />}
    </StyledLoginBanner>
  );
};

export default LoginBanner;
